import { useEffect, useState } from 'react';

import { ProgramGrades } from 'shared/lib/grades';

import { useClasses } from './use-classes';

export const useAllClassesData = () => {
  const [allClassesKeys, setAllClassesKeys] = useState<string[]>([]);
  const [allClassesGrades, setAllClassesGrades] = useState<ProgramGrades[]>([]);

  const { classes } = useClasses();

  useEffect(() => {
    if (!classes?.length) return;

    setAllClassesKeys(() => classes.map((cl) => cl.classKey));
    setAllClassesGrades(() => [
      ...new Set(classes.map((cl) => cl.grades).flat()),
    ]);
  }, [classes]);

  return {
    allClassesKeys,
    allClassesGrades,
    isClassesLoading: classes === null,
  };
};
